import { render, staticRenderFns } from "./product-sidepanel.html?vue&type=template&id=c379ac2e&scoped=true&"
import script from "./product-sidepanel.js?vue&type=script&lang=js&"
export * from "./product-sidepanel.js?vue&type=script&lang=js&"
import style0 from "./product-sidepanel.scss?vue&type=style&index=0&id=c379ac2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c379ac2e",
  null
  
)

export default component.exports